export default "__VITE_ASSET__Bu6$6cuj__"